import { render, staticRenderFns } from "./FlexTablePro.vue?vue&type=template&id=a4dd8c28&scoped=true"
import script from "./FlexTablePro.vue?vue&type=script&lang=js"
export * from "./FlexTablePro.vue?vue&type=script&lang=js"
import style0 from "./FlexTablePro.vue?vue&type=style&index=0&id=a4dd8c28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dd8c28",
  null
  
)

export default component.exports